export const WORDS = [
  'jesus',
  'choir',
  'grace',
  'saved',
  'glory',
  'reign',
  'serve',
  'faith',
  'works',
  'prays',
  'aaron',
  'sarah',
  'kings',
  'david',
  'priest',
  'elder',
  'christ',
  'jesus',
  'hades',
  'sheol',
  'saint',
  'enoch',
  'james',
  'herod',
  'jacob',
  'moses',
  'micah',
  'peter',
  'simon',
  'titus',
  'psalm',
  'judas',
  'hosea',
  'jonah',
  'nahum',
  'uriel',
  'flood',
  'grape',
  'fruit',
  'branch',
  'olive',
  'doves',
  'snake',
  'lions',
  'sheep',
  'bread',
  'truth',
  'blood',
  'cross',
  'tobit',
  'wrath',
  'guilt',
  'anger',
  'light',
  'flesh',
  'crown',
  'thorn',
  'robed',
  'signs',
  'demon',
  'angel',
  'water',
  'judah',
  'house',
  'shall',
  'stone',
  'honey',
]
